export const refundPolicyConstants = {
    GET_REFUND_POLICY_DATA: "GET_REFUND_POLICY_DATA",
    UDPATE_REFUND_POLICY_TYPE: "UDPATE_REFUND_POLICY_TYPE",
  };
  